import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Col, Form, Input, notification, Row, Select } from "antd";
import { POST } from "../../utils/apicalls";
import { API } from "../../config/api";
import { login } from "../../redux/slice/userslice";
import { Container } from "react-bootstrap";
import "../login/login.css";
import Logo from "../../assests/papalogo.png";

import Type from "../employee/helpers/type.json";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const onFinish = async (values: any) => {
    try {
      setLoading(true);

      // Client-side password validation
      if (!values.password || values.password.length < 6) {
        notification.error({
          message: "Invalid Password",
          description: "Password must be at least 6 characters long.",
        });
        setLoading(false);
        return;
      }

      const obj = {
        userName: values.userName,
        password: values.password,
        type: values.type,
      };

      // Use different API endpoints based on user type
      const url =
        values.type === "admin"
          ? API.ADMIN_LOGIN
          : values.type === "client"
            ? API.CLIENT_LOGIN
            : API.EMPLOYEE_LOGIN;

      const { data, status, message }: any = await POST(url, obj);

      if (!status) {
        notification.error({ message: "Invalid username or password." });
        setLoading(false);
        return;
      }

      // If authentication is successful
      notification.success({ message });

      dispatch(login(data));
      localStorage.setItem("user", JSON.stringify(data));

      // Redirect based on user type
      switch (data.type) {
        case "admin":
          navigate("/Admin");
          break;
        case "receptionist":
          navigate("/Receptionist");
          break;
        case "client":
          navigate("/Client");
          break;
        case "telecaller":
          navigate("/Telecaller");
          break;
        case "accountant":
          navigate("/Accountant");
          break;
        case "hr":
          navigate("/HR");
          break;
        default:
          navigate("/Employee");
      }
    } catch (error) {
      console.error("Login failed:", error);
      notification.error({ message: "Login failed. Please try again." });
    } finally {
      setLoading(false);
    }
  };



  return (
    <div className="login-screen">
      <Container >
        <div className="loginScreen">
          <Row gutter={16}>
            <Col span={8}>
              <img
                src={Logo}
                alt="logo"
                style={{
                  height: "200px",
                  display: "flex",
                  justifyContent: "center",
                  paddingLeft: "50px",
                  width: "200px",
                }}
              ></img>
              <div className="loginScreen-txt1">Login and Continue</div>
              <Form onFinish={onFinish} className="form">
                <label className="formLabel">Email or Username</label>
                <Form.Item
                  name="userName"
                  rules={[{ required: true, message: "Required" }]}
                >
                  <Input size="large" />
                </Form.Item>

                <label className="formLabel">Password</label>
                <Form.Item
                  name="password"
                  rules={[{ required: true, message: "Required" }]}
                >
                  <Input.Password size="large" />
                </Form.Item>
                <label className="formLabel">Type</label>
                <Form.Item name="type">
                  <Select placeholder="Select Type">
                    {Type?.map((des) => (
                      <Select.Option key={des.value} value={des.value}>
                        {des.title}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Button
                  block
                  size="large"
                  htmlType="submit"
                  type="primary"
                  loading={loading}
                  style={{ height: 50 }}
                >
                  Sign In
                </Button>
              </Form>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default Login;
